export { default } from './SpecialPagesList';



// WEBPACK FOOTER //
// ./src/components/SpecialPages/SpecialPagesList/index.js